/* eslint-disable react/prop-types */
import React from 'react'
import { CToaster, CToast, CToastHeader, CToastBody } from '@coreui/react'
import { useToast } from '../contexts/ToastContext'

const ToastContainer = ({ placement = 'top-end' }) => {
  const { toasts, removeToast } = useToast()

  if (toasts.length === 0) {
    return null
  }

  return (
    <CToaster placement={placement}>
      {toasts.map((toast) => (
        <CToast
          key={toast.id}
          autohide={false}
          visible={true}
          onClose={() => removeToast(toast.id)}
        >
          <CToastHeader closeButton>
            <svg
              className="rounded me-2"
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid slice"
              focusable="false"
              role="img"
            >
              <rect width="100%" height="100%" fill={toast.isError ? '#dd1122' : '#11dd22'}></rect>
            </svg>
            <strong className="me-auto">{toast.title}</strong>
          </CToastHeader>
          <CToastBody>{toast.message}</CToastBody>
        </CToast>
      ))}
    </CToaster>
  )
}

export default ToastContainer
